import { motion } from 'framer-motion';
import { Check, Home } from 'lucide-react';
import { PRONTUARIO_BG_CLASS } from '@/pages/professional/sessao-chamada/constants/prontuarioTheme';
import { cn } from '@/lib/utils';

type SessionEndCallSuccessProps = {
	onGoHome: () => void;
};

const FADE_TRANSITION = { duration: 0.45, ease: [0.32, 0.72, 0, 1] as const };

const SessionEndCallSuccess = ({ onGoHome }: SessionEndCallSuccessProps) => (
	<motion.div
		className={cn(
			'absolute inset-0 z-50 flex flex-col overflow-hidden',
			PRONTUARIO_BG_CLASS,
		)}
		initial={{ opacity: 0 }}
		animate={{ opacity: 1 }}
		transition={FADE_TRANSITION}
	>
		<div className="flex flex-1 items-center justify-center p-6">
			<motion.div
				className="flex w-full max-w-[420px] flex-col items-center text-center"
				initial={{ opacity: 0, y: 12 }}
				animate={{ opacity: 1, y: 0 }}
				transition={FADE_TRANSITION}
			>
				<motion.span
					className="mb-5 flex size-16 items-center justify-center rounded-full bg-[#8ab4f8] text-[#0f1722]"
					initial={{ scale: 0 }}
					animate={{ scale: [0, 1.2, 1] }}
					transition={{
						duration: 0.5,
						ease: 'easeOut',
						times: [0, 0.6, 1],
					}}
				>
					<Check size={30} strokeWidth={3} />
				</motion.span>
				<h2 className="text-[20px] font-semibold text-[#e8eaed]">
					Sessão finalizada com sucesso!
				</h2>
				<p className="mt-2 text-[14px] leading-relaxed text-[#9aa0a6]">
					A consulta foi encerrada. Suas anotações manuais no
					prontuário foram preservadas.
				</p>
				<div className="mt-8 flex w-full flex-col gap-3">
					<button
						type="button"
						onClick={onGoHome}
						className="flex w-full items-center justify-center gap-2 rounded-full bg-[#8ab4f8] py-3 font-bold text-[#0f1722] transition-colors hover:bg-[#9cc1fa]"
					>
						<Home
							className="size-4"
							strokeWidth={2.5}
							aria-hidden
						/>
						Ir para tela inicial
					</button>
				</div>
			</motion.div>
		</div>
	</motion.div>
);

export { SessionEndCallSuccess };
